import defaultAvatar from "../../assets/logo/logo.png";
import { API_BASE_URL } from "../../services/api";
import "../../styles/driver_modal.css";
import { useState,useEffect } from "react";



export default function DriverDetailsModal({ driver, onClose }) {
 
  const [docsLoaded, setDocsLoaded] = useState(false);
  const [tab, setTab] = useState("info");

 useEffect(() => {
  if (tab === "documents" && !docsLoaded) {
    setDocsLoaded(true);
  }
}, [tab]);
useEffect(() => {
  if (driver) {
    setTab("info");
    setDocsLoaded(false);
  }
}, [driver]);

  if (!driver) return null;
  const user = driver.user;
  const driverOrderTypes = driver.driver_order_types
    ? driver.driver_order_types
        .map((dot) => dot.order_type?.name)
        .filter((name, idx, arr) => name && arr.indexOf(name) === idx)
        .join(", ") || "Aucun"
    : "Aucun";
  const avatar = user?.profilPicture
    ? `${API_BASE_URL.replace("/api", "")}/images/user/${user.profilPicture}`
    : defaultAvatar;

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <div className="modalHeader">
          <img src={avatar} alt="avatar" className="modalAvatar" />
          <div>
            <div className="modalName">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="modalRole">
              <span style={{ fontWeight: "bold", color: "black" }}>
                Type de chauffeur:
              </span>{" "}
              {driverOrderTypes}
            </div>
            <div className="modalDins">
              Insrit le{" "}
              {new Date(driver.created_at).toLocaleString("fr-FR", {
                dateStyle: "medium",
                timeStyle: "short",
              })}
            </div>
          </div>
          <button className="modalClose" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="modalTabs">
          <button
            className={tab === "info" ? "active" : ""}
            onClick={() => setTab("info")}
          >
            Infos
          </button>

        <button
  className={tab === "documents" ? "active" : ""}
  onClick={() => setTab("documents")}
>
  Documents {!docsLoaded && <span className="dotLoader" />}
</button>
        </div>

        {/* TAB */}
        {tab === "info" && (
          <>
            <div className="modalSection">
              <div className="modalSectionTitle">Informations générales</div>

              <div className="modalGrid">
                <Info label="Username" value={user?.username} />
                <Info label="Solde" value={`${driver.balance} CFA`} />
                <Info
                  label="Statut"
                  value={driver.isApproved ? "Approuvé" : "Non approuvé"}
                />
                <Info
                  label="Disponibilité"
                  value={driver.isActive ? "Actif" : "Inactif"}
                />
              </div>
            </div>

            <div className="modalSection">
              <div className="modalSectionTitle">Contact</div>

              <div className="modalGrid">
                <Info label="Téléphone" value={user?.contact?.tel} />
                <Info label="Email" value={user?.contact?.email} />
                <Info label="WhatsApp" value={user?.contact?.whatsapp} />
                <Info
                  label="Percentage"
                  value={`${driver.orderPercentage} %`}
                />
              </div>
            </div>
          </>
        )}

        {tab === "documents" && docsLoaded && (
          <div className="modalSection">
            <div className="modalSectionTitle">Documents chauffeur</div>
            {/* <DriverDocumentsSection driver={driver} /> */}
          </div>
        )}
      </div>
    </div>
  );
}

function Info({ label, value }) {
  return (
    <div className="infoItem">
      <span className="infoLabel">{label}</span>
      <span className="infoValue">{value || "-"}</span>
    </div>
  );
}

function LicenceCard({ label, image }) {
  const src = image
    ? `${API_BASE_URL.replace("/api", "")}/images/driverLicence/${image}`
    : null;

  return (
    <div className="licenceCard">
      <span className="infoLabel">{label}</span>

      {src ? (
        <a href={src} target="_blank" rel="noreferrer">
          <img src={src} alt={label} />
        </a>
      ) : (
        <div className="licenceEmpty">Non fournie</div>
      )}
    </div>
  );
}
